/**
 * responsive_engagement.js
 * Script pour rendre la section engagement et traffic responsive
 */

document.addEventListener('turbolinks:load', function() {
  // Améliorer la responsivité des sections d'engagement et trafic
  makeEngagementCardsResponsive();

  // Écouter les changements de taille d'écran
  window.addEventListener('resize', makeEngagementCardsResponsive);
});

function makeEngagementCardsResponsive() {
  const isMobile = window.innerWidth < 768;

  // Ajuster les badges pour qu'ils soient plus lisibles sur mobile
  const badges = document.querySelectorAll('.badge.bg-light.rounded-pill');
  badges.forEach(badge => {
    if (isMobile) {
      // S'assurer que les badges sont lisibles sur mobile
      badge.style.fontSize = '0.85rem';
    } else {
      badge.style.fontSize = '';
    }
  });

  // Rendre les cartes cliquables plus évidentes
  const clickableCards = document.querySelectorAll('.card.cursor-pointer');
  clickableCards.forEach(card => {
    card.addEventListener('click', function() {
      const href = this.getAttribute('data-href');
      if (href) {
        window.location.href = href;
      }
    });

    // Ajouter un effet de survol
    card.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px)';
      this.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
      this.querySelector('.bi-chevron-right').style.transform = 'translateX(3px)';
    });

    card.addEventListener('mouseleave', function() {
      this.style.transform = '';
      this.style.boxShadow = '';
      this.querySelector('.bi-chevron-right').style.transform = '';
    });
  });

  // Améliorer les cartes d'engagement pour mobile
  const engagementCards = document.querySelectorAll('.card.bg-white.border-0');
  engagementCards.forEach(card => {
    if (isMobile) {
      card.style.transition = 'all 0.3s ease';
    }
  });
}
